import { onTurboPageLoad, reloadWithTurbo } from "../turboHelper";
import { getModel } from "../modelHelper";
import { postRequestAndWaitForJobCompletion } from "../jobCompletion";
import { ITriggerZone } from "../sharedModels";
import { IGpsCoordinates } from "../_generated/IGpsCoordinates";
import { IBoundingBox } from "../_generated/IBoundingBox";

onTurboPageLoad("Tours/Detail", () => {
    const model = getModel<ITourDetailModel>();

    $(".removePoiFromTourButton").on("click", e => {
        bootbox.confirm("Really remove Place from the tour?", result => {
            if (!result) return;

            const actionButton = $(e.currentTarget);
            const poiContentUniqueId = actionButton.data("poi-content-unique-id");
            const removePoiFromTourUrl = model.removePoiFromTourUrl.replace("$poiContentUniqueId", poiContentUniqueId);

            postRequestAndWaitForJobCompletion(removePoiFromTourUrl,
                undefined,
                model.jobCompletionUrl,
                actionButton,
                () => {
                    reloadWithTurbo();
                }
            );
        });
    });

    $(".addPoiToDestinationButton").on("click", e => {
        bootbox.confirm("Really add Place to the destination?", result => {
            if (!result) return;

            const actionButton = $(e.currentTarget);
            const poiContentUniqueId = actionButton.data("poi-content-unique-id");
            const addPoiToDestinationUrl = model.addPoiToDestinationUrl.replace("$poiContentUniqueId", poiContentUniqueId);

            postRequestAndWaitForJobCompletion(addPoiToDestinationUrl,
                undefined,
                model.jobCompletionUrl,
                actionButton,
                () => {
                    reloadWithTurbo();
                }
            );
        });
    });
});

interface ITourDetailPoiScriptModel {
    coordinates: IGpsCoordinates;
    name: string;
    mainImageUrl: string;
    triggerZones: ITriggerZone[];
}

interface ITourDetailScriptModel {
    boundingBox: IBoundingBox;
    name: string;
    mainImageUrl: string;
    routeWaypoints: IGpsCoordinates[];
    tourPois: ITourDetailPoiScriptModel[];
}

interface ITourDetailModel {
    scriptModel: ITourDetailScriptModel;
    removePoiFromTourUrl: string;
    addPoiToDestinationUrl: string;
    movePoiUrl: string;
    jobCompletionUrl: string;
}